


































































































































































































































































import ActionBar from '@/components/action-bar/action-bar.vue';
import PageLoader from '@/components/page-loader/page-loader.vue';
import { CONFIG } from '@/config';
import { StoreType, UpdatedAtStatus } from '@/enums';
import WizardProgress from '@/modules/dap/components/wizard-progress/wizard-progress.vue';
import WizardStoreClose from '@/modules/dap/containers/wizard-store-close/wizard-store-close.vue';
import WizardStoreConvert from '@/modules/dap/containers/wizard-store-convert/wizard-store-convert.vue';
import WizardStoreEdit from '@/modules/dap/containers/wizard-store-edit/wizard-store-edit.vue';
import WizardStoreUpdateHistory
  from '@/modules/dap/containers/wizard-store-update-history/wizard-store-update-history.vue';
import { DapSpreadsheetType, DapType, StoreDialogVisibility, StoreFilterProperty } from '@/modules/dap/enums';
import { IProject, IStoreProject } from '@/modules/dap/interfaces';
import { Project, StoreProject } from '@/modules/dap/models';
import { DAP_ROUTES } from '@/modules/dap/router';
import { DapSpreadsheetFactory } from '@/modules/dap/services';
import { dateService, httpService, stringService } from '@/services';
import { AxiosError, AxiosResponse } from 'axios';
import * as _ from 'lodash';
import { debounceTime, distinctUntilChanged, pluck, startWith } from 'rxjs/operators';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  subscriptions () {
    return {
      searchValue$: this.$watchAsObservable('searchValue').pipe(
        pluck('newValue'),
        debounceTime(400),
        distinctUntilChanged(),
        startWith('')
      )
    };
  },
  components: {
    ActionBar,
    PageLoader,
    WizardProgress,
    WizardStoreClose,
    WizardStoreConvert,
    WizardStoreEdit,
    WizardStoreUpdateHistory
  }
})
export default class DapWizardStorePage extends Vue {
  @Prop()
  public projectId: number;

  @Prop()
  public wizardStep: number;

  public DAP_ROUTES = DAP_ROUTES;
  public StoreDialogVisibility = StoreDialogVisibility;
  public currentDialog = StoreDialogVisibility.None;
  public StoreType = StoreType;
  public UpdatedAtStatus = UpdatedAtStatus;
  public selectedUpdatedAtStatus = String(UpdatedAtStatus.Any);
  public searchValue: string = '';
  public searchValue$: string;
  public currentPage: number = 1;
  public searchField: number = StoreFilterProperty.name;
  public parseDateToString = dateService.parseDateToString;
  public parseToMoment = dateService.parseToMoment;
  public selectedStore: IStoreProject = this.createStoreProject();
  public oldStore: null | IStoreProject = null;
  public project: IProject = new Project();

  public storeColumnOrder = 'name';

  public storeColumnOrderDataSource = [
    {
      text: 'Nome',
      value: 'name'
    },
    {
      text: 'Grupo',
      value: 'groupName'
    },
    {
      text: 'DN',
      value: 'dealerNumber'
    },
    {
      text: 'DN Matriz',
      value: 'idStoreMatrix'
    },
    {
      text: 'Cidade',
      value: 'city'
    },
    {
      text: 'UF',
      value: 'state'
    }
  ];

  public searchFieldOptions = [
    {
      text: 'Nome do Dealer',
      value: StoreFilterProperty.name
    },
    {
      text: 'DN',
      value: StoreFilterProperty.dealerNumber
    },
    {
      text: 'DN Matriz',
      value: StoreFilterProperty.idStoreMatrix
    },
    {
      text: 'Grupo',
      value: StoreFilterProperty.groupName
    },
    {
      text: 'Tipo',
      value: StoreFilterProperty.typeName
    },
    {
      text: 'UF',
      value: StoreFilterProperty.state
    },
    {
      text: 'Cidade',
      value: StoreFilterProperty.city
    }
  ];

  public gotToEditProject (projectId: number) {
    this.$router.push({
      name: DAP_ROUTES.WIZARD_EDIT,
      params: { projectId: String(projectId) }
    });
  }

  public createStoreProject (): any {
    return new StoreProject();
  }

  public get storesView () {
    const perPage = 25;
    const stores = _(this.project ? this.project.storeProjects : [])
      .filter((store: IStoreProject) => {
        switch (+this.selectedUpdatedAtStatus) {
          case UpdatedAtStatus.LastWeek:
            return !store.updatedAt
              ? false
              : +store.updatedAt >
              +dateService
                .parseToMoment()
                .endOf('day')
                .subtract(1, 'week')
                .toDate();
          case UpdatedAtStatus.LastMonth:
            return !store.updatedAt
              ? false
              : +store.updatedAt >
              +dateService
                .parseToMoment()
                .endOf('day')
                .subtract(1, 'month')
                .toDate();
          default:
            return true;
        }
      })
      .filter((store: any) => {
        const property: string = StoreFilterProperty[this.searchField];
        return _.size(this.searchValue$)
          ? stringService.normalize(store[property]).includes(stringService.normalize(this.searchValue$))
          : true;
      })
      .orderBy((p: any) => p[this.storeColumnOrder])
      .chunk(perPage)
      .value();

    const totalPages = stores.length;
    const page = this.currentPage > totalPages ? 1 : this.currentPage;
    const pages = [page];
    const pagesTotal = totalPages < 5 ? totalPages : 5;

    if (totalPages > 1) {
      let isLeft = true;
      while (pages.length < pagesTotal) {
        if (isLeft && pages[0] > 1) {
          pages.splice(0, 0, pages[0] - 1);
        } else if (pages[pages.length - 1] < totalPages) {
          pages.push(pages[pages.length - 1] + 1);
        }
        isLeft = !isLeft;
      }
    }

    return {
      page: page,
      perPage: perPage,
      offset: (page - 1) * perPage,
      total: this.project ? this.project.storeProjects.length : 0,
      totalPages,
      pages,
      data: stores[this.currentPage - 1] || []
    };
  }

  public getStoreUpdateStatusColor (store: IStoreProject) {
    return (+store.initialValidity >
      +dateService
        .parseToMoment()
        .endOf('day')
        .subtract(1, 'month')
        .toDate() &&
      store.percentGrowth === undefined) ||
    (store.dateClosing && (store.percentDivision === undefined || !store.percentRate === undefined))
      ? 'changed-error'
      : !store.updatedAt
        ? 'not-changed'
        : +store.updatedAt >
        +dateService
          .parseToMoment()
          .endOf('day')
          .subtract(1, 'month')
          .toDate()
          ? 'changed-one-week-ago'
          : +store.updatedAt >
          +dateService
            .parseToMoment()
            .endOf('day')
            .subtract(1, 'month')
            .toDate()
            ? 'changed-one-monthReference-ago'
            : 'not-changed';
  }

  public addStoreToMatrix (store: IStoreProject) {
    this.selectedStore = _.assign({}, this.createStoreProject(), {
      matrixName: store.name,
      idStoreMatrix: store.dealerNumber,
      groupName: store.groupName,
      idStoreTypeClient: StoreType['2S'],
      idEconomicGroup: store.idEconomicGroup,
      idCity: store.idCity,
      percentGrowth: 0,
      isNew2S: true,
      projectId: this.projectId
    });
    this.currentDialog = StoreDialogVisibility.Add2s;
  }

  public addStoreMatrix () {
    this.selectedStore = _.assign({}, this.createStoreProject(), {
      matrixName: '',
      groupName: '',
      idStoreMatrix: 0,
      idStoreTypeClient: StoreType['3S'],
      isNew: true,
      salesInformed: _.cloneDeep(this.project.families),
      percentGrowth: undefined
    });
    this.currentDialog = StoreDialogVisibility.Add;
  }

  public storeUpdateHistory (store: IStoreProject) {
    this.selectedStore = _.assign({}, store);
    this.currentDialog = StoreDialogVisibility.UpdateHistory;
  }

  public editStore (store: IStoreProject) {
    this.selectedStore = _.assign({}, store);
    this.currentDialog = StoreDialogVisibility.Edit;
  }

  public convertStore (store: IStoreProject) {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/dap/store/${this.projectId}/matrix/${store.idStoreMatrix}/stores`)
      .then((res: AxiosResponse) => {
        const branchs = res.data;
        store.branchs = _.map(_.orderBy(branchs, ['idStoreTypeClient'], ['desc']), currentStore => {
          if (currentStore.id == store.id) {
            currentStore.idStoreTypeClientFuture = StoreType['3S'];
          }
          if (!currentStore.idStoreTypeClientFuture) {
            currentStore.idStoreTypeClientFuture = StoreType['2S'];
          }

          currentStore.idStoreTypeFuture = null;

          currentStore.dateConversion = currentStore.dateConversion ? new Date(currentStore.dateConversion) : null;

          if (!currentStore.percentRate)
            currentStore.percentRate = (100 - currentStore.cityOperationTypePercentRate) / 100;

          if (!currentStore.percentDivision)
            currentStore.percentDivision = currentStore.cityOperationTypePercentConversion / 100;

          return currentStore;
        });
        this.selectedStore = _.assign({}, store);
        this.currentDialog = StoreDialogVisibility.Convert;
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public sellStore (store: any) {
    this.selectedStore = _.assign({}, this.createStoreProject());
    this.selectedStore.percentGrowth = undefined;
    this.oldStore = store;
    this.currentDialog = StoreDialogVisibility.Sell;
  }

  public closeStore (store: IStoreProject) {
    if (store.dateClosing) {
      store.dateClosing = new Date(store.dateClosing);
    }
    this.selectedStore = _.assign({}, store);
    this.currentDialog = StoreDialogVisibility.Close;
  }

  public serviceUpdateStore (store: IStoreProject) {
    httpService.http
      .put(`${CONFIG.URL.NEODASH_API}/api/dap/store/${this.projectId}/${store.id}`, store)
      .then((res: AxiosResponse) => {
        this.loadProject();
      })
      .catch((err: AxiosError) => console.log(err.message));

    this.currentDialog = StoreDialogVisibility.None;
  }

  public serviceConvertStore (store: any) {
    httpService.http
      .put(`${CONFIG.URL.NEODASH_API}/api/dap/store/${this.projectId}/${store.id}/convert`, store)
      .then((res: AxiosResponse) => {
        this.loadProject();
      })
      .catch((err: AxiosError) => console.log(err.message));

    this.currentDialog = StoreDialogVisibility.None;
  }

  public serviceSellStore (store: any) {
    httpService.http
      .put(`${CONFIG.URL.NEODASH_API}/api/dap/store/${this.projectId}/sell`, store)
      .then((res: AxiosResponse) => {
        this.loadProject();
      })
      .catch((err: AxiosError) => console.log(err.message));

    this.currentDialog = StoreDialogVisibility.None;
  }

  public serviceCreateStore3s (store: any) {
    this.createStore(store, StoreType['3S']);
    this.currentDialog = StoreDialogVisibility.None;
  }

  public serviceCreateStore2s (store: any) {
    this.createStore(store, StoreType['2S']);
    this.currentDialog = StoreDialogVisibility.None;
  }

  public serviceCloseStore (store: any) {
    httpService.http
      .put(`${CONFIG.URL.NEODASH_API}/api/dap/store/${this.projectId}/${store.id}/close`, store)
      .then((res: AxiosResponse) => {
        this.loadProject();
      })
      .catch((err: AxiosError) => console.log(err.message));

    this.currentDialog = StoreDialogVisibility.None;
  }

  public downloadStoresAsExcel () {
    DapSpreadsheetFactory.get(
      DapSpreadsheetType.Stores,
      this.project.storeProjects.map((s: any) => {
        s.initialHistoryPeriod = this.project.initialHistoryPeriod;
        s.finalHistoryPeriod = this.project.finalHistoryPeriod;
        return s;
      })
    )
      .create()
      .saveAsExcel();
  }

  public goBack () {
    this.$router.push({
      name: DAP_ROUTES.PROJECT,
      params: { projectId: String(this.projectId) }
    });
  }

  public onCancel () {
    this.currentDialog = StoreDialogVisibility.None;
  }

  public created () {
    this.loadProject();
  }

  public createStore (store: any, storeType: StoreType) {
    store.idEconomicGroup = store.idEconomicGroup ? store.idEconomicGroup : store.idEconomicGroup.value;
    store.idCity = store.idCity && store.idCity.value ? store.idCity.value : store.idCity;
    store.pointHistories = undefined;
    store.projectId = undefined;

    // this.setIdLocaleAgg(store);
    this.setStoreType(store, storeType);

    httpService.http
      .post(`${CONFIG.URL.NEODASH_API}/api/dap/store/${this.projectId}/createStoreProject`, store)
      .then((res: AxiosResponse) => {
        this.loadProject();
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public nextStep () {
    this.$router.push({
      name: this.DAP_ROUTES.WIZARD_CONFIGURATION,
      params: {
        projectId: String(this.projectId)
      },
      query: {
        wizardStep: String(this.wizardStep) || '1',
        dapType: String(DapType.Simple)
      }
    });
  }

  private loadProject () {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}/store`)
      .then((res: AxiosResponse) => {
        this.project = res.data;
        this.project.storeProjects.forEach((store: any) => {
          store.dateOpening = new Date(store.dateOpening);
          store.dateSchedule = store.dateSchedule ? new Date(store.dateSchedule) : undefined;
          store.updatedAt = store.updatedAt ? new Date(store.updatedAt) : null;

          if (store.storeMatrixName) {
            store.matrixName = store.storeMatrixName;
          } else {
            store.matrixName = ((_.find(
              this.project.storeProjects,
              (s: any) => s.dealerNumber === store.dealerNumber
            ) || { name: '' })).name;
          }
        });
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public setStoreType (store: any, storeType: StoreType) {
    if (storeType === StoreType['3S']) {
      store.idStoreType = 1;
      store.idStoreTypeClient = 3;
      return;
    }

    store.idStoreType = 2;
    store.idStoreTypeClient = 2;
  }
}
